class NSSBlogRecipeGetInspired extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Blog Recipe Get Inspired] Connected.");

    this.initCarousel();

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ]
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  initCarousel() {
    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      grabCursor: true,
      loop: true,
      autoHeight: true,
      centeredSlides: false,
      slidesPerView: 1,
      spaceBetween: 20,
      direction: "horizontal",
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      a11y: {
        enabled: true,
      },
      navigation: {
        prevEl: '.nss-blog-recipe-get-inspired-button-prev',
        nextEl: '.nss-blog-recipe-get-inspired-button-next',
      },
    });
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Carousel] Handle editor event, e:", e);

    switch(e.type) {

      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Carousel] slideEl:", slideEl);
        if (slideEl) {
          // const index = slideEl.getAttribute(`data-swiper-slide-index`);
          const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
          const index = slideEls.indexOf(slideEl);
          if (this.debug) console.log("[NSS][Carousel] Sliding to index:", index);
          this.swiper.slideTo(index);
        }
        break;

    }
  }
}

let elementName = `nss-blog-recipe-get-inspired`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSBlogRecipeGetInspired);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}